export const PAYPAL_PLAN_ID_DEV = 'P-7UT88129HK745982ML6SHD3Y'
export const PAYPAL_PLAN_ID_PROD = 'P-2AB21107805470013L76J32Q'
